import axios from 'axios';
import debounce from 'awesome-debounce-promise';

const token = typeof document !== 'undefined' ? document.head.querySelector('meta[name="_token"]') : '';

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

function actualGetProducts({
  sortBy,
  dateAdded,
  categoryFilters,
  page,
  searchTags,
  optionalWords,
  perPage,
  excludeProductIds,
  filters,
}) {
  const request = {
    sortBy,
    dateAdded,
    categoryFilters,
    page,
    searchTags,
    optionalWords,
    perPage,
    excludeProductIds,
    filters,
  };
  const url = '/api/products/search';
  return axios.post(url, request)
    .then((response) => {
      const { data } = response;
      const { meta } = data;
      const currentPage = parseInt(meta.current_page, 10);
      const lastPage = parseInt(meta.last_page, 10);
      const totalResults = parseInt(meta.total, 10);
      const _perPage = parseInt(meta.per_page, 10);

      return {
        products: data.products,
        currentPage,
        lastPage,
        totalResults,
        perPage: _perPage,
      };
    });
}

// wait for this long after last user filter change to send request to server
export const getProducts = debounce(actualGetProducts, 100);
